// extracted by mini-css-extract-plugin
module.exports = {"button":"TileButton_button__HgrJY","buttonWide":"TileButton_buttonWide__iWXCP"};